import { render, staticRenderFns } from "./personalDistributionWithdrawal.vue?vue&type=template&id=6b9131da&scoped=true"
import script from "./personalDistributionWithdrawal.vue?vue&type=script&lang=js"
export * from "./personalDistributionWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9131da",
  null
  
)

export default component.exports